import React, { FC, ReactNode, useRef } from 'react';
import classNames from 'classnames';
import { motion, MotionStyle } from 'framer-motion';

interface IAsideHeadProps {
	children: ReactNode;
}
export const AsideHead: FC<IAsideHeadProps> = ({ children }) => {
	return <div className='aside-head'>{children}</div>;
};

interface IAsideBodyProps {
	children: ReactNode;
}
export const AsideBody: FC<IAsideBodyProps> = ({ children }) => {
	return <div className='aside-body'>{children}</div>;
};

interface IAsideFootProps {
	children: ReactNode;
}
export const AsideFoot: FC<IAsideFootProps> = ({ children }) => {
	return <div className='aside-foot'>{children}</div>;
};

interface IAsideProps {
	children: any;
}
const Aside: FC<IAsideProps> = ({ children }) => {
	const constraintsRef = useRef(null);

	return (
		<>
			<motion.aside
				style={{ backgroundColor: '#5D023D' } as MotionStyle}
				className={classNames(
					'aside',
					'open', // Always keep the aside open
					'overflow-auto',
				)}>
				{children}
			</motion.aside>
		</>
	);
};

export default Aside;
